export const NAV = {
  NAV_PAGE_START: 'NAV_PAGE_START',
  NAV_PAGE_FOCUS: 'NAV_PAGE_FOCUS',
};
